<template>
    <b-modal
        ref="dialog"
        title-tag="h2"
        title="Send Email"
        :lazy="true"
        no-enforce-focus
        @hidden="close"
        no-close-on-backdrop
        no-close-on-esc
    >
        <b-form>
            <b-form-group label-cols="3" label="To:" label-for="to">
                <recepients-email
                    v-model="recipient"
                    multiple
                    placeholder="Client or Contact Email (required)"
                    :client="clientDetails"
                    :key="recipientComponentKey"
                    v-validate="'required'"
                    name="recipient"
                    :class="{
                        'border-danger': formError.includes('recipient')
                    }"
                />
            </b-form-group>

            <b-form-group label-cols="3" label="Subject:" label-for="subject">
                <b-form-input
                    v-model="subject"
                    placeholder="Subject (required)"
                    v-validate="'required'"
                    name="subject"
                    :class="{
                        'border-danger': formError.includes('subject')
                    }"
                />
            </b-form-group>

            <b-form-group label-cols="3" label="Message:" label-for="Message">
            </b-form-group>

            <tinymce
                :init="tinymceConfig"
                placeholder="Communication (required)"
                v-model="message"
            />
        </b-form>

        <template v-slot:modal-footer>
            <loader v-if="isSending" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isSending"
            >
                Cancel
            </b-button>

            <b-button v-if="!isSending" variant="primary" @click="send">
                Send
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import RecepientsEmail from "@/components/commons/recipients-email";
import Loader from "@/module/commons/loader";
import tinymce from "@tinymce/tinymce-vue";
import tinymceHelper from "@/module/commons/helper-tinymce";
import axios from "axios";

export default {
    components: {
        RecepientsEmail,
        Loader,
        tinymce
    },
    props: {
        patientDetails: {
            type: Object
        }
    },
    data() {
        return {
            communication: null, // if this not null, then this is resend
            isSending: false,
            subject: "",
            recipient: [],
            clientId: null,
            message: "",
            clientDetails: null,
            recipientComponentKey: 0,
            tinymceConfig: {
                ...tinymceHelper.core, // use spread operator to inject all vetter-related configs
                height: 300,
                toolbar: tinymceHelper.toolbar.default, // default | communication
                plugins: tinymceHelper.plugins
            },
            formError: []
        };
    },
    watch: {
        recipient(value) {
            if (value.length > 0) {
                this.formError = this.formError.filter(
                    err => err !== "recipient"
                );
            }
        },
        subject(value) {
            if (value !== "") {
                this.formError = this.formError.filter(
                    err => err !== "subject"
                );
            }
        }
    },
    methods: {
        open(communication) {
            this.communication = communication || null;
            this.setDefaultRecipient();
            this.$refs.dialog.show();

            if (this.communication) {
                this.message = this.communication.raw_content;
            }
        },
        close() {
            this.$refs.dialog.hide();
        },
        async send() {
            try {
                this.formError = [];
                let hasError = false;

                if (this.recipient.length === 0) {
                    this.formError.push("recipient");
                    hasError = true;
                }

                if (this.subject === "") {
                    this.formError.push("subject");
                    hasError = true;
                }

                if (hasError) {
                    return;
                }

                const {
                    id: patientId,
                    primary_owner: owners
                } = this.patientDetails;

                let senderId = owners && owners[0] ? owners[0].id : "";
                const recipients = this.extractRecipientIds(this.recipient);

                if (!senderId) {
                    senderId = recipients[0];
                }

                this.isSending = true;

                const formData = new FormData();
                formData.append("pid", patientId);
                formData.append("sender_id", senderId);
                formData.append("rtype", "client");
                formData.append("module_id", 1);
                formData.append("subject", this.subject);
                formData.append("message", this.message);
                formData.append("is_system_generated", false);

                // For Resend Email
                // set the reference type & reference id
                if (this.communication) {
                    formData.append("resent_communication", true);
                    formData.append("communication_id", this.communication.id);
                }

                formData.append(
                    "timestamp",
                    Math.floor(new Date().getTime() / 1000)
                );

                for (const id of recipients) {
                    formData.append("to[]", id);
                }

                const res = await axios.post(
                    `${process.env.CI_APPS}common/communication/send_email`,
                    formData
                );

                if (res.data.state === 0) {
                    this._message(res.data.message);
                } else {
                    throw new Error(res.data.message);
                }

                // After send the message
                this.isSending = false;
                this.close();
                this.$emit("onsuccess");
            } catch (e) {
                this.isSending = false;
                this._message(e.message, "danger");
            }
        },
        extractPatientIds(patients = []) {
            let res = [];
            for (const patient of patients) {
                res.push(patient.id);
            }
            return res;
        },
        extractRecipientIds(recipients = []) {
            let res = [];
            for (const recipient of recipients) {
                res.push(recipient.to_id);
            }
            return res;
        },
        setDefaultRecipient() {
            const owners = this.patientDetails.primary_owner;

            for (const owner of owners) {
                if (owner && owner.email && owner.email !== "") {
                    this.clientDetails = owner;
                    this.recipientComponentKey++; // force re-render
                    break;
                }
            }
        }
    }
};
</script>
